import {
  AbstractControlOptions,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationAvFormBuilder extends PrFormAbstract {
  options;

  generate(entity: any, options?: any) {
    this.options = options;

    return this.formBuilder.group({
      productId: [entity ? entity.productId : null, null],
      initialDeposit: [
        entity ? entity.initialDeposit : null,
        Validators.required,
      ],
      monthlyDeposit: [
        entity ? entity.monthlyDeposit : null,
        Validators.required,
      ],
      durationInYears: [
        entity ? entity.durationInYears : null,
        Validators.required,
      ],
      entryFee: [
        entity ? entity.entryFee * 100 : null,
        this.prFormService.AddValidatorsBasedOnCondition(
          () => options && options.sessionConsultant,
          Validators.required,
        ),
      ],
    });
  }

  extract() {
    let dto: any = {
      id: null,
      productId: this.emptyIsNull(this.form.value.productId),
      initialDeposit: this.emptyIsNull(this.form.value.initialDeposit),
      monthlyDeposit: this.emptyIsNull(this.form.value.monthlyDeposit),
      durationInYears: this.emptyIsNull(this.form.value.durationInYears),
      entryFee: this.emptyIsNull(this.form.value.entryFee / 100),
    };
    return dto;
  }
}
